import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Home from './home/index.page';
import { getMessage } from '@/utils/I18nUtils';

export default function Index() {
  return (
   <Home />
  )
}

export const getServerSideProps = async (context: any) => {
  const { locale } = context;

  const translations : any = await serverSideTranslations(locale, ["common"]);

  return {
    props: {
      ...translations,
      metadata : {
        title : getMessage(translations, locale, 'title'),
        description : getMessage(translations, locale, 'slogan')
      }
    }
  };
};
 